import { OpeningHours, isCurrentlyOpen } from "./OpeningHoursEditor";
import { cn } from "@/lib/utils";

interface OpenClosedBadgeProps {
  hours: OpeningHours | null;
  className?: string;
  size?: "sm" | "md";
}

export const OpenClosedBadge = ({
  hours,
  className,
  size = "md",
}: OpenClosedBadgeProps) => {
  // Don't render if no structured hours
  if (!hours) return null;

  const isOpen = isCurrentlyOpen(hours);

  return (
    <div
      className={cn(
        "rounded-full font-semibold shadow-lg",
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-xs",
        isOpen
          ? "bg-green-600 text-white"
          : "bg-red-600 text-white",
        className
      )}
    >
      {isOpen ? "OPEN" : "CLOSED"}
    </div>
  );
};
